import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./SchPublicationsUIHelpers";

const SchPublicationsUIContext = createContext();

export function useSchPublicationsUIContext() {
  return useContext(SchPublicationsUIContext);
}

export const SchPublicationsUIConsumer = SchPublicationsUIContext.Consumer;

export function SchPublicationsUIProvider({ schPublicationsUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    newSchPublicationButtonClick: schPublicationsUIEvents.newSchPublicationButtonClick,
    openEditSchPublicationPage: schPublicationsUIEvents.openEditSchPublicationPage,
    openDeleteSchPublicationDialog: schPublicationsUIEvents.openDeleteSchPublicationDialog,
    openDeleteSchPublicationsDialog: schPublicationsUIEvents.openDeleteSchPublicationsDialog,
    openFetchSchPublicationsDialog: schPublicationsUIEvents.openFetchSchPublicationsDialog,
  };

  return (
    <SchPublicationsUIContext.Provider value={value}>
      {children}
    </SchPublicationsUIContext.Provider>
  );
}
